import React from 'react';
import MuiCheckbox from '@mui/material/Checkbox';
import styled from 'styled-components';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CheckOrangeSvg from 'shared/statics/svg/Check-Orange.svg';
import { COLORS } from '../design-system/settings/variables/Colors';

const CheckedIcon = styled.img.attrs({
  src: CheckOrangeSvg,
})`
  width: 16px;
  height: 16px;
  border: 1px solid #f89915;
  border-radius: 3px;
  padding: 1px;
`;

const CheckedIconWhite = styled(FontAwesomeIcon).attrs({
  icon: faCheck,
  size: 'sm',
})`
  width: 16px !important;
  height: 16px !important;
  border: 1px solid ${COLORS.whiteBase};
  border-radius: 3px;
  padding: 1px;
  color: ${COLORS.ctaPrimary} !important;
  background-color: white;
`;

const UncheckedIcon = styled.div`
  width: 16px;
  height: 16px;
  border: 1px solid #cbd6e2;
  border-radius: 3px;
  padding: 1px;
`;

const UncheckedIconWhite = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid #cbd6e2;
  border-radius: 3px;
  padding: 1px;
`;

const Checkbox = styled(MuiCheckbox).attrs({
  size: 'small',
  icon: <UncheckedIcon />,
  checkedIcon: <CheckedIcon />,
})``;

export const CheckboxWhite = styled(MuiCheckbox).attrs({
  size: 'small',
  icon: <UncheckedIconWhite />,
  checkedIcon: <CheckedIconWhite />,
})``;

export default Checkbox;
